import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';

import { Segment, Grid, Form, Image, Input, Dropdown, Popup } from 'semantic-ui-react';
import { Tooltip, IconButton } from 'material-ui';

import { Button, ModalEduAdd, EduList } from 'components';
import { CtEduHeader } from 'containers';

import styles from './Edu.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class EduContent extends Component {
  constructor(props) {
    super(props);
  }

  // 훈련 결과 입력
  onSearchChange = e => {
    const { takeSearchValue } = this.props;
    takeSearchValue(e.target.value);
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      selectEduNo,
      tagDataByTagNo,
      eduTargetOrdering,
      eduTargetDataByTargetNo,
      eduTargetParam,
      eduSummaryByEduNo,
      isLoading,
      page,
      totalPages,
      eduScrollData,
      onGetEduTarget,
      onSortOrdering,
      onSearchEduTarget,
      onRefScroll,
      handleSelectEduTarget
    } = this.props;
    // 선택 이벤트
    const { handleSelectEdu } = this.props;
    // 필터
    const { onFilterCancel, searchTextRef, filterUpdate } = this.props;

    let examInfoArray =
      eduTargetParam.getIn(['filter', 'examInfoArray']) && eduTargetParam.getIn(['filter', 'examInfoArray']).toJS();

    let targetDivisionArray =
      eduTargetParam.getIn(['filter', 'targetDivisionArray']) &&
      eduTargetParam.getIn(['filter', 'targetDivisionArray']).toJS();

    let targetPositionArray =
      eduTargetParam.getIn(['filter', 'targetPositionArray']) &&
      eduTargetParam.getIn(['filter', 'targetPositionArray']).toJS();

    if (examInfoArray === undefined) {
      examInfoArray = [];
    }
    if (targetDivisionArray === undefined) {
      targetDivisionArray = [];
    }
    if (targetPositionArray === undefined) {
      targetPositionArray = [];
    }

    const filterDivisionArray = [];
    const filterPositionArray = [];

    if (targetDivisionArray.length > 0) {
      targetDivisionArray.map((division, index) => {
        filterDivisionArray.push(division);
      });
    }
    if (targetPositionArray.length > 0) {
      targetPositionArray.map((position, index) => {
        filterPositionArray.push(position);
      });
    }

    const isFiltered = !!eduTargetParam.getIn(['filter', 'searchAll']);

    return (
      <div className={cx('edu-wrapper')}>
        <CtEduHeader />
        <div className={cx('target-subHeader')}>
          <Segment vertical>
            <Grid columns="equal" stackable>
              <Grid.Row textAlign="left">
                <Grid.Column className={cx('target-filter-area')} textAlign="right">
                  <div className={cx('search-input-area')}>
                    <Input
                      size="mini"
                      placeholder={defineMessages(formatMessage({ id: 'Target_14', defaultMessage: '검색' }))}
                      onChange={this.onSearchChange}
                      onKeyPress={onSearchEduTarget}
                      ref={searchTextRef}
                    />
                    <Button
                      id="bt-searchTarget"
                      fontColor="#757575"
                      size="mini"
                      icon={<img src="/img/exam/list_search.png" />}
                      onClick={onSearchEduTarget}
                    />
                  </div>
                  <Tooltip
                    title={defineMessages(formatMessage({ id: 'Target_13', defaultMessage: '필터 해제' }))}
                    placement="top">
                    <IconButton className={cx('bt-filterCancel')} onClick={onFilterCancel}>
                      <Image src={'/img/table/btn_filter' + (isFiltered ? '_active' : '') + '.png'} />
                    </IconButton>
                  </Tooltip>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </div>
        <EduList
          eduTargetOrdering={eduTargetOrdering}
          eduTargetDataByTargetNo={eduTargetDataByTargetNo}
          tagDataByTagNo={tagDataByTagNo}
          selectEduNo={selectEduNo}
          eduSummaryByEduNo={eduSummaryByEduNo}
          handleSelectEduTarget={handleSelectEduTarget}
          eduScrollData={eduScrollData}
          onRefScroll={onRefScroll}
          page={page}
          totalPages={totalPages}
          onGetEduTarget={onGetEduTarget}
          isLoading={isLoading}
          filterUpdate={filterUpdate}
        />
      </div>
    );
  }
}

EduContent.propTypes = {
  handleSelectEdu: PropTypes.func
};

export default injectIntl(EduContent);



// WEBPACK FOOTER //
// ./src/script/components/edu/EduContent.js